// src/services/AuthService.js

import axios from 'axios';


import serveradresse_settings from '@/settings/serveradresse_settings.js';
const url = serveradresse_settings.config_server_adresse.url;

// const url = 'http://localhost:3100/api/';
//const url = 'https://api.technik-seenotretter.de/api/';


export default {
  async zeigestationen(credentials) {
    return axios
      .post(url + 'zeigestationen/', credentials)
      .then(response => response.data);
  },

  
  async zeigeallestationen(credentials) {
    return axios
      .post(url + 'zeigeallestationen/', credentials)
      .then(response => response.data);
  },


};